type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

const SortIcon = (props: Props) => {
  const {
    width = '25',
    height = '26',
    viewBox = '0 0 25 26',
    fillColor = '#F2D093',
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M18.7507 22.75L14.584 18.4167H17.709V7.58333H14.584L18.7507 3.25L22.9173 7.58333H19.7923V18.4167H22.9173M2.08398 20.5833V18.4167H12.5007V20.5833M2.08398 14.0833V11.9167H9.37565V14.0833M2.08398 7.58333V5.41667H6.25065V7.58333H2.08398Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default SortIcon;
